import { RefundDetailsModel } from "model/RefundDetails.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RefundDetailsModel | null;

export const useDefaultObservableRefundDetailsModelNull = createUseDefaultObservable<RefundDetailsModel | null>();

export class BehaviorSubjectRefundDetailsModelNull extends BehaviorSubject<CurrentType> {}
